import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCategory, setTags } from "../../appState/slices/auth/authSlice";
import { useParams } from "react-router-dom";

const CategoryDropDown = ({ updateSelectedFilter }) => {
  const dispatch = useDispatch();

  const selectedcategory = useSelector((state) => state.auth.category.category);
  const selectedTags = useSelector((state) => state.auth.tags);

  // Ensure safe fallback (IMPORTANT)
  const availableTags = useSelector((state) => state.product.availableTags) || [];
  const collectioncategories = useSelector((state) => state.product.categories) || [];

  const { collection, category: categoryName } = useParams();

  const handleSelectTernaryCategory = (tag) => {
    dispatch(setTags(tag));
    updateSelectedFilter("category");
  };

  const handleSelectCategory = (categoryId) => {
    dispatch(setCategory(categoryId));
    updateSelectedFilter("collection");
  };

  return (
    <div className="categoriesdropdown">

      {/* ---------- CATEGORY PAGE TAGS ----------- */}
      {categoryName &&
        availableTags.map((tag) => (
          <div
            key={tag}
            className={`categorypill ${
              selectedTags.includes(tag) ? "productsizeselected" : ""
            }`}
            onClick={() => handleSelectTernaryCategory(tag)}
          >
            {tag}
          </div>
        ))
      }

      {/* ---------- COLLECTION PAGE CATEGORIES ----------- */}
      {collection &&
        collectioncategories.map((category) => (
          <div
            key={category._id}
            className={`categorypill ${
              selectedcategory === category._id ? "productsizeselected" : ""
            }`}
            onClick={() => handleSelectCategory(category._id)}
          >
            {category.name}
          </div>
        ))
      }

    </div>
  );
};

export default CategoryDropDown;
